import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import notEqualized from "./components/not-equalized";
import equalized from "./components/equalized";

const principle: Slide = {
  description:
    "Below, the transfer characteristics of different headphones have been simulated by convolving an audio track with binaural Headphone Transfer Functions (HpTFs) measured on an artificial head. In the example, the equalization target is set to a flat frequency response. Differences in coloration for different headphones should be reduced when equalization is applied. Keep in mind that your hearing impression is also influenced by the transfer characteristic of your own playback device.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Not Equalized" }, { name: "Equalized" }],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], []],
      components: [notEqualized, equalized],
    },
  },
};

export default principle;
